import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Enum } from './enum.resource';
import { Firm } from './firm.resource';
import { Job } from './job.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { FormGroup } from '@angular/forms';

@Resource({
  type: 'contacts',
})
export class Contact extends AtomResource {
  @Attribute() name?: string;
  @Attribute() email?: string;
  @Attribute() phone?: string;
  @Attribute() adress?: string;
  @Attribute() zipcode?: string;
  @Attribute() city?: string;
  @Attribute({ key: 'type' }) contactType?: string;

  @Relationship() firm?: Firm;
  @Relationship() job?: Job;
  @Relationship() enumtype?: Enum;
}
export class ContactConfig implements ResourceConfig {
  hosted = 'firm';
  tables = {
    options: {
      copy: true,
    },
    includes: ['firm', 'enumtype'],
    columns: [
      {
        columnDef: 'name',
        displayedDatas: [
          { path: ['name'], class: 'mat-body-2' },
          { path: ['enumtype.label'], class: 'mat-body-1' },
        ],
        header: 'Name',
        displayed: true,
      },
      {
        columnDef: 'adress',
        displayedDatas: [
          { path: ['adress'], class: 'mat-body-2' },
          { path: ['zipcode', 'city'], class: 'mat-body-1' },
        ],
        header: 'Adress',
        displayed: true,
      },
      {
        columnDef: 'phone',
        displayedDatas: [{ path: ['phone'], class: 'mat-body-2' }],
        header: 'Phone',
        displayed: true,
      },
      {
        columnDef: 'email',
        displayedDatas: [{ path: ['email'], class: 'mat-body-2' }],
        header: 'Email',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'Contact',
        formGroup: 'contact',
        list: [
          {
            type: 'enum',
            title: 'Type',
            formControl: 'contactType',
            APIKey: 'contactType',
            fieldKey: 'type',
            multiple: false,
            required: true,
            noCols: true,
          },
          {
            type: 'text',
            title: 'Name',
            formControl: 'name',
            APIKey: 'name',
            required: true,
            noCols: true,
          },
          {
            type: 'text',
            title: 'Email',
            formControl: 'email',
            APIKey: 'email',
          },
          {
            type: 'text',
            title: 'Phone Number',
            formControl: 'phone',
            APIKey: 'phone',
          },
          {
            type: 'text',
            title: 'Adress',
            formControl: 'adress',
            APIKey: 'adress',
            noCols: true,
          },
          {
            type: 'text',
            title: 'ZIP Code',
            formControl: 'zipcode',
            APIKey: 'zipcode',
          },
          {
            type: 'text',
            title: 'City',
            formControl: 'city',
            APIKey: 'city',
          },
        ],
      },
    ],
  };
  resource = Contact;
  resourceName = 'contacts';
  resourceKey = 'contacts';
  resourceKeySingle = 'contact';
  includes = ['firm', 'enumtype'];
  filters = [];
  constructor() {}
}
